module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab8/awsop-lab8.component.css
// module id = ./src/app/course/labs/awsop/awsop-lab8/awsop-lab8.component.css
// module chunks = main